import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <section id="categories" className="bg-background-50 py-14 md:py-20 scroll-mt-20 md:scroll-mt-24">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="font-heading text-2xl md:text-4xl font-bold tracking-tight text-foreground-950">
            {t('category.title')}
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
            {t('category.subtitle')}
          </p>
        </div>

        <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.key}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group rounded-lg border border-background-200 bg-background-100 overflow-hidden transition-colors hover:border-primary-300 cursor-pointer"
            >
              <div className="aspect-square overflow-hidden bg-background-200">
                <img
                  src={cat.image}
                  alt={t(`category.${cat.key}`)}
                  title={`${t(`category.${cat.key}`)} USFans`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex items-center justify-between gap-2 px-3 py-3 md:px-4 md:py-3.5">
                <span className="text-sm md:text-base font-medium text-foreground-900 whitespace-nowrap">
                  {t(`category.${cat.key}`)}
                </span>
                <span className="w-5 h-5 flex items-center justify-center text-foreground-400 group-hover:text-primary-600 transition-colors">
                  <i className="ri-arrow-right-up-line text-base" aria-hidden="true"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}